"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateLogin = void 0;
const com = require("../com/tmpls");
const StatePaged_1 = require("./abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
class StateLogin extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageLogin, "AstraCab", true, false);
        this._sid = "";
        this.page.ctrls.btnSend.onclick = () => __awaiter(this, void 0, void 0, function* () { return yield this.tryLogin(); });
        this.page.ctrls.btnSendAgain.onclick = () => __awaiter(this, void 0, void 0, function* () { return yield this.tryLogin(); });
        this.page.ctrls.btnConfirm.onclick = () => __awaiter(this, void 0, void 0, function* () { return yield this.tryConfirm(); });
        this.page.ctrls.btnCancel.onclick = () => __awaiter(this, void 0, void 0, function* () { return yield gs_1.StateGS.Run(StateLogin); });
        this.page.ctrls.formConfirmCode.hide();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.gui.topBar.hide();
            this.gui.leftBar.hide();
            return _super.start.call(this);
        });
    }
    tryLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = yield this.page.ctrls.formPhone.getFormData();
            if (!formData.phone)
                return;
            this.app.api.setSid(null);
            const authSession = yield this.lockgui(this.app.api.admin.auth.authByPhone(formData.phone));
            if (!authSession)
                return;
            this._sid = authSession.sid;
            this.app.api.setSid(this._sid);
            this.page.ctrls.formConfirmCode.show();
            this.page.ctrls.formPhone.hide();
            this.page.ctrls.taCode.el.focus();
        });
    }
    tryConfirm() {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = yield this.page.ctrls.formConfirmCode.getFormData();
            if (!formData.code)
                return;
            const user = yield this.lockgui(this.app.api.admin.auth.confirmPhone(formData.code));
            if (!user)
                return;
            yield this.app.auth.login(user, this._sid);
        });
    }
}
exports.StateLogin = StateLogin;
StateLogin.StateName = "login";
//# sourceMappingURL=StateLogin.js.map